import { useState, useEffect } from "react";
import "./Zwischenmomenten.css";

const baseUrl = "https://kolektanto.org/zwischenmomenten/";

const photos = [
  "260418_105345_Iceland",
  "260418_111335_Iceland",
  "260418_145624_Iceland",
  "260418_171828_Iceland",
  "260418_175208_Iceland",
  "260418_175640_Iceland"
];

export default function Zwischenmomenten() {
  const [index, setIndex] = useState(null);

  const openImage = (i) => setIndex(i);
  const close = () => setIndex(null);

  const prev = () => {
    setIndex((i) => (i === 0 ? photos.length - 1 : i - 1));
  };

  const next = () => {
    setIndex((i) => (i === photos.length - 1 ? 0 : i + 1));
  };

  // Keyboard support
  useEffect(() => {
    const handleKey = (e) => {
      if (index === null) return;

      if (e.key === "Escape") close();
      if (e.key === "ArrowLeft") prev();
      if (e.key === "ArrowRight") next();
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [index]);

  return (
    <div className="zwischenmomenten-page">
      <div className="gallery-container">
        <h1>Zwischenmomenten – Island</h1>

        {/* GRID */}
        <div className="gallery-grid">
          {photos.map((id, i) => (
            <div key={id} className="image-card" onClick={() => openImage(i)}>
              <img
                src={`${baseUrl}${id}_n_s.jpg`}
                alt=""
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>

      {/* LIGHTBOX */}
      {index !== null && (
        <div className="lightbox" onClick={close}>
          
          {/* prevent closing when clicking image/buttons */}
          <button
            className="lightbox-nav left"
            onClick={(e) => {
              e.stopPropagation();
              prev();
            }}
          >
            ‹
          </button>

          <img
            src={`${baseUrl}${photos[index]}_n.jpg`}
            alt=""
            onClick={(e) => e.stopPropagation()}
          />

          <button
            className="lightbox-nav right"
            onClick={(e) => {
              e.stopPropagation();
              next();
            }}
          >
            ›
          </button>
        </div>
      )}
    </div>
  );
}